import { ReactNode } from 'react';

import { Skeleton } from 'components/Blocks';

interface TriStateWrapperProps {
  children: ReactNode;
  loading?: boolean;
  message?: string | null | false | undefined;
}

export function TriStateWrapper({ children, loading, message }: TriStateWrapperProps): JSX.Element {
  if (loading) return <Skeleton quantity={4} height={90} />;

  if (message) return <p>{message}</p>;

  return <>{children}</>;
}
